import {uniqueId} from 'lodash';

export default class PipelineStepModel {
    id = '';
    name = '';
    parents = [];
    pipeline = null;
    isSaved = false;

    constructor({id, name, parents = [], pipeline}) {
        Object.assign(this, {
            id: id || uniqueId('pipeline_step_'),
            name,
            pipeline,
            parents: parents.slice(),
        });
    }

    apply(table) {
        return {before: table, after: table, table};
    }

    isNew() {
        return !this.isSaved;
    }

    markSaved() {
        this.isSaved = true;
    }
}
